import { Listener } from './listener';

/**
 * Observable object that can emit events to a list of listeners.
 *
 * @note See [../../../documentation/subjects.md] for additional information.
 */
export class Subject<T> {
  private _listeners: Listener<T>[] = [];

  /** Emit the next event to all the current listeners. */
  next(event: T): void {
    this._listeners.forEach((listener) => {
      listener(event);
    });
  }

  /** Subscribe a listener to wait for events. */
  subscribe(listener: Listener<T>): void {
    this._listeners = this._listeners.concat(listener);
  }

  /** Unsubscribe a listener to stop waiting for events. */
  unsubscribe(listener: Listener<T>): void {
    this._listeners = this._listeners.filter((l) => {
      return l !== listener;
    });
  }
}
